import configdata from "../../config.json";
import { subQualitySliceAction } from "./SubQualitySlice";
import { getApi } from "../BaseApi";
import { getOnlyValueFromSelectObject } from "../UseAbleFun";
import { appLevelSliceActions } from "../AppLevelApi/AppLevelSlice";
export const getAllSubQualityItems = () => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/sub-qualities`
    );
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(subQualitySliceAction.getAllSubQuality(res.data.subQuality));
  };
};
export const createSubQualityItem = (data) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const { form } = getOnlyValueFromSelectObject(data);

    const res = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/sub-qualities/store`,
      form
    );

    if (res?.error) {
      if (res?.erroType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: res.message, isError: true })
        );
      } else {
        dispatch(
          subQualitySliceAction.setErrorData({
            message: res.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      subQualitySliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(subQualitySliceAction.setInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(getAllSubQualityItems());
  };
};
export const getDataForEdit = (id, qualityList) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/sub-qualities/edit/${id}`
    );
    dispatch(appLevelSliceActions.setLoadingState());
    const data = { ...res.data.subquality[0] };
    const quality = qualityList.find((item) => {
      return item.value === data.quality_id;
    });

    data.quality = {
      value: quality.value,
      label: quality.label,
      type: quality.type,
    };
    data.status = {
      value: `${data.status}`,
      label: data.status === "active" ? "Active" : "Deactive",
      type: "status",
    };
    dispatch(subQualitySliceAction.getSubQualityDataEdit(data));
  };
};

export const updateSubQualityItem = (data) => {
  const { form } = getOnlyValueFromSelectObject(data);

  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/sub-qualities/update/${data.id}`,
      form
    );
    if (res?.error) {
      if (res?.erroType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: res.message, isError: true })
        );
      } else {
        dispatch(
          subQualitySliceAction.setErrorData({
            message: res.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }

    dispatch(
      subQualitySliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(subQualitySliceAction.setInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(getAllSubQualityItems());
  };
};

export const deleteSubQualityItem = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    await getApi(
      "get",
      `${configdata.SERVER_URL}/api/sub-qualities/delete/${id}`
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(appLevelSliceActions.setLoadingState());
  };
};
